import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Combines conditional class names while resolving conflicting Tailwind utilities. */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
